import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { UserNonConformancesRoutes } from 'src/app/core/enums/routes.enum';
import { CommentsListDialogComponent } from 'src/app/non-conformance-user/components/comments-list-dialog/comments-list-dialog.component';
import { NonConformanceAction } from 'src/app/non-conformance-user/enums/non-conformance-action.enum';
import { NonConformanceStatus } from 'src/app/non-conformance-user/enums/non-conformance-status.enum';
import { SUBTASK_ACTIONS_LABELS } from 'src/app/non-conformance-user/enums/subtask-actions.enum';
import { subtaskStatusLabels } from 'src/app/non-conformance-user/enums/subtask-status.enum';
import { RestoreNonConformance } from 'src/app/non-conformance-user/state/non-conformance.actions';
import { AlertStatus } from 'src/app/risk-assessment-user/enums/alert-status.enum';
import { CommentEntityTypes } from 'src/app/shared/comments/enums/comment-entity-types.enum';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { RestoreCustomProperty } from 'src/app/non-conformance-admin/state/custom-property/custom-property.actions';
import { Privileges } from 'src/app/core/privileges/privileges';
import { SubtaskStatus } from '../../../../../non-conformance-user/enums/subtask-status.enum';

@Component({
  selector: 'app-non-conformance-template',
  templateUrl: './non-conformance-template.component.html',
  styleUrls: ['./non-conformance-template.component.scss'],
  standalone: false,
})
export class NonConformanceTemplateComponent implements OnInit {
  @Input() columnName: string;
  @Input() element: any;
  @Input() showStatusDotInName = false;
  showAlertWarnings = false;
  showSubtaskWarnings = false;
  alertStatus = AlertStatus;
  subtaskStatusLabels = subtaskStatusLabels;
  subtaskActionLabels = SUBTASK_ACTIONS_LABELS;
  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;

  nonConformanceAction = NonConformanceAction;
  Privileges = Privileges;

  constructor(
    private router: Router,
    private store: Store,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.showAlertWarnings =
      this.element.status === NonConformanceStatus.Open ||
      this.element.status === NonConformanceStatus.Completed;
    this.showSubtaskWarnings =
      this.element.alertStatus !== AlertStatus.Ok &&
      (this.element.status === SubtaskStatus.NotStarted ||
        this.element.status === SubtaskStatus.InProgress);
  }

  viewPreviousReport(nonConformanceId: string, responseId: string): void {
    const link = UserNonConformancesRoutes.ViewReport.replace(':id', nonConformanceId).replace(
      ':rid',
      responseId
    );
    this.router.navigate([link]);
  }

  restore(): void {
    this.store.dispatch(new RestoreNonConformance(this.element.id));
  }

  restoreCustomProperty(): void {
    this.store.dispatch(new RestoreCustomProperty(this.element.id));
  }

  showSubtaskComments(): void {
    this.dialog.open(CommentsListDialogComponent, {
      autoFocus: false,
      panelClass: 'mobile-sizing-for-mat-dialogs',
      data: {
        entityType: CommentEntityTypes.SUBTASK,
        entityId: this.element.id,
        canAddComment: true,
        privilege: Privileges.NonConformanceRead,
        adminPrivilege: Privileges.NonConformancesAdmin,
        showDeleteButton: false,
      },
    });
  }
}
